export default {
  "LogoPreview": "_LogoPreview_25glg_1",
  "FullStack": "_FullStack_25glg_10"
};import "ni:sha-256;sQqTHnahbRUAVr6zKswmWgVoskG7btFtxjIwMVFOVlY";